"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.importTranslationFile = importTranslationFile;
async function importFallbackTranslationFile() {
    return (await Promise.resolve().then(() => __importStar(require('transifex/languages/en.json'))));
}
async function importTranslationFile(locale) {
    var _a, _b;
    const localeKey = locale.slice(0, 2).toLowerCase();
    let translationFile = {};
    try {
        translationFile = (await ((_b = (_a = {
            en: () => Promise.resolve().then(() => __importStar(require('transifex/languages/en.json'))),
            es: () => Promise.resolve().then(() => __importStar(require('transifex/languages/es.json'))),
            fr: () => Promise.resolve().then(() => __importStar(require('transifex/languages/fr.json'))),
            pt: () => Promise.resolve().then(() => __importStar(require('transifex/resources/pt_BR.json')))
        })[localeKey]) === null || _b === void 0 ? void 0 : _b.call(_a)));
        return translationFile || (await importFallbackTranslationFile());
    }
    catch (_c) {
        return await importFallbackTranslationFile();
    }
}
